module.exports = __webpack_public_path__ + "media/images/Arrow-Left-9d475e03b22ad8980e0decf09ac745c8.svg";